import { useTranslation } from 'react-i18next';

const OnboardingExperienceStep = ({ formData, onChange, toggleArrayValue }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="app-modal-step-intro">
        <h3>{t('onboarding_experience_title', 'Your experience')}</h3>
        <p className="app-modal-text-muted">
          {t(
            'onboarding_experience_intro',
            'A few final questions to help us understand how you use All-Voiced.'
          )}
        </p>
      </div>

      <div className="app-modal-section">
        <p className="app-modal-label">
          {t(
            'voice_competence_question',
            'How would you describe your level of experience with voice?'
          )}
        </p>
        <select
          name="voiceCompetenceLevel"
          value={formData.voiceCompetenceLevel}
          onChange={onChange}
          className="app-input"
        >
          <option value="">{t('select_voice_competence_level')}</option>
          <option value="beginner">{t('beginner')}</option>
          <option value="intermediate">{t('intermediate')}</option>
          <option value="advanced">{t('advanced')}</option>
          <option value="expert">{t('expert')}</option>
        </select>
      </div>

      <div className="app-modal-section">
        <p className="app-modal-label">
          {t(
            'main_use_question',
            'What do you expect to use All-Voiced for?'
          )}
        </p>
        {[
          { value: 'learning', label: t('learning_training', 'Learning / Training') },
          { value: 'teaching', label: t('teaching', 'Teaching') },
          { value: 'research', label: t('research', 'Research') },
          { value: 'clinical', label: t('clinical_work', 'Clinical work') },
          { value: 'other', label: t('other', 'Other') }
        ].map(use => (
          <label key={use.value} className="checkbox-container">
            <input
              type="checkbox"
              checked={formData.mainUse.includes(use.value)}
              onChange={() => toggleArrayValue('mainUse', use.value)}
            />
            {use.label}
          </label>
        ))}
      </div>

      <div className="app-modal-section">
        <p className="app-modal-label">
          {t(
            'onboarding_discovery_title',
            'How did you hear about All-Voiced?'
          )}
        </p>
        <p className="app-modal-text-muted">
          {t(
            'onboarding_discovery_intro',
            'This helps us understand how the All-Voiced community grows.'
          )}
        </p>
        {[
          { value: 'colleague_or_friend', label: 'A colleague or friend' },
          { value: 'university', label: 'University' },
          { value: 'course_or_workshop', label: 'Course or workshop' },
          { value: 'conference', label: 'Conference or congress' },
          { value: 'scientific_literature', label: 'Scientific literature' },
          { value: 'social_media', label: 'Social media' },
          { value: 'search_engine', label: 'Search engine' },
          { value: 'other', label: 'Other' }
        ].map(source => (
          <label key={source.value} className="checkbox-container">
            <input
              type="checkbox"
              checked={formData.howDidYouHear.includes(source.value)}
              onChange={() => toggleArrayValue('howDidYouHear', source.value)}
            />
            {source.label}
          </label>
        ))}
      </div>
    </>
  );
};

export default OnboardingExperienceStep;
